export default __webpack_public_path__ + "static/media/coming.cfb22d37.jpeg";